import { Pipe, PipeTransform } from '@angular/core';
import { AnalysisParameter } from '@services/cleanfill-api/cleanfill-api.generated';

@Pipe({
  name: 'analysisParameter'
})
export class AnalysisParameterPipe implements PipeTransform {
  transform(value: AnalysisParameter): string {
    return this.getLabel(value);
  }

  getLabel(analysisParameter: AnalysisParameter): string {
    switch (analysisParameter) {
      case AnalysisParameter.F1F4:
        return 'F1F4';
      case AnalysisParameter.VOC:
        return 'VOC';
      case AnalysisParameter.SVOC:
        return 'SVOC';
      case AnalysisParameter.Metals:
        return 'Metals';
      case AnalysisParameter.Inorg:
        return 'Inorg';
      case AnalysisParameter.PCB:
        return 'PCB';
      case AnalysisParameter.Pest:
        return 'Pest';
      case AnalysisParameter.Other:
        return 'Other';
      default:
        return '';
    }
  }
}
